import React from 'react';
import { connect } from "react-redux";
import { useHistory } from 'react-router';
import * as rk from '../../localization/resourceKeys';
import { withTranslation } from 'react-i18next'
import { SkipNavLink } from "@reach/skip-nav";
import BottomLine from '../Footer/BottomLine';
import i18n from "../../i18n";
import './rightToCorrect.css';

const DataCorrection = (props) => {
    const history = useHistory();

    const { currentStateResidence, customerRelation } = { ...props.stateSelector };

    const showAlternativeText = currentStateResidence === i18n.t(rk.STATE_CALIFORNIA) && customerRelation !== i18n.t(rk.QUESTION_2_OPTION_2);
    const dataCorrectionButtonText = showAlternativeText ? i18n.t(rk.DATA_CORRECTION.LANDING_BUTTON_B2B) : i18n.t(rk.DATA_CORRECTION.LANDING_BUTTON);
    const dataCorrectionButtonText2 = showAlternativeText ? i18n.t(rk.DATA_CORRECTION.LANDING_BUTTON_2_B2B) : i18n.t(rk.DATA_CORRECTION.LANDING_BUTTON_2);
    return (
        <>
            <SkipNavLink />
            <div className="o-layout u-m-none u-mb-small">
                <div className="u-1/1 u-m-none u-mb welcome-note">
                    <span>{i18n.t(rk.DATA_CORRECTION.LANDING_TEXT)}</span>
                </div>
            </div>

            <div className="o-layout u-m-none">
                <div id="status-buttons-div" className="o-layout__item u-1/1 u-m-none">
                    <div className="button-wrapper">
                        <div className="sg-component-variant">
                            <button
                                data-test-id='vwgoa-btn'
                                id='vwgoa-btn'
                                className="c-btn  c-btn--secondary submit-status-button-text"
                                onClick={() => {
                                    history.push({ pathname: '/mailingAddress' });
                                }}
                            >
                                <span className="c-btn__text">
                                    {dataCorrectionButtonText}
                                </span>
                            </button>
                        </div>
                        <div>
                            <button
                                data-test-id='vw-credit-btn'
                                id='vw-credit-btn'
                                className="c-btn  c-btn--secondary check-status-button-text"
                                onClick={() => {
                                    history.push("/dataCorrectionVCI");
                                }}
                            >
                                <span className="c-btn__text">
                                    {dataCorrectionButtonText2}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='request-footer-wrapper'>
                <BottomLine />
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    stateSelector: state.stateSelector,
});

export default connect(mapStateToProps) (withTranslation()(DataCorrection));
